import { Routes, Route } from 'react-router-dom';
import { PromoReleasePage } from './release/promo-release.page';
import { PromoAccessPage } from './access/promo-access.page';
import { PromoFeedbackPage } from './feedback/promo-feedback.page';

export const PromoRoutes = () => {
  return (
    <Routes>
      <Route path=":id" element={<PromoReleasePage />} />
      <Route path=":id/access" element={<PromoAccessPage />} />
      <Route path=":id/feedback" element={<PromoFeedbackPage />} />
    </Routes>
  );
};
